const redirectPopup = (function() {
    const popup = {
      init: function() {
        this.popup = document.querySelector('.section-redirect-popup');
        if (!this.popup) {
          console.error('Popup container not found');
          return;
        }
        const popupCloseButtons = this.popup.querySelectorAll('a[href="#"], .popup-overlay');
        popupCloseButtons.forEach(button => {
          button.addEventListener('click', this._closePopup.bind(this));
        });
        if (this.getCookie('redirect_checked') === 'true') {
          return;
        }
        fetch('https://api.ipify.org')
          .then(response => response.text())
          .then(ip => {
            fetch('https://freeipapi.com/api/json/' + ip)
              .then(response => response.json())
              .then(data => {
                if (data.countryCode === window.country_code_redirect) {
                  this._openPopup();
                }
                this.setCookie('redirect_checked', 'true', 31);
              });
          });
      },
      _closePopup: function() {
        this.popup.style.display = 'none';
        document.body.style.overflow = '';
      },
      _openPopup: function() {
        this.popup.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      },
      setCookie: function(name, value, days) {
        const d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
      },
      getCookie: function(name) {
        const cname = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(cname) == 0) {
            return c.substring(cname.length, c.length);
          }
        }
        return "";
      }
    };
  
    return popup;
  })();
  
  // Initialize the popup
  document.addEventListener('DOMContentLoaded', function() {
    redirectPopup.init();
  });
  